(() => {
  if (window.mareldNewsletterInterestsInstalled) return;
  window.mareldNewsletterInterestsInstalled = true;
  const allowed = new Set([
    'mareld-interesse-mode', 'mareld-interesse-schuhe',
    'mareld-interesse-schmuck', 'mareld-interesse-accessoires'
  ]);
  function sync(form) {
    const tags = form.querySelector('[data-mareld-newsletter-tags]');
    if (!tags) return;
    const selected = Array.from(form.querySelectorAll('[data-mareld-interest]'))
      .filter(input => input.checked && allowed.has(input.value))
      .map(input => input.value);
    tags.value = ['newsletter', ...new Set(selected)].join(',');
  }
  function initialize(root) {
    root.querySelectorAll('[data-mareld-newsletter-interests]').forEach(group => {
      const form = group.closest('form');
      if (!form) return;
      sync(form);
      group.hidden = false;
    });
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-mareld-interest]')) {
      const form = event.target.closest('form');
      if (form) sync(form);
    }
  });
  // Capture phase also covers scripts that serialize the form during submission.
  document.addEventListener('submit', event => {
    if (event.target.matches('form') && event.target.querySelector('[data-mareld-newsletter-tags]')) sync(event.target);
  }, true);
  document.addEventListener('reset', event => {
    if (event.target.matches('form') && event.target.querySelector('[data-mareld-newsletter-tags]')) {
      setTimeout(() => sync(event.target), 0);
    }
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
})();
